module.exports = __webpack_public_path__ + "img/01.3278a86d.jpg";